/* PDP redesign (Oct 2026): scroll reveal for card grids + mobile swipe carousel with dots and gentle auto-advance. */
(function () {
  if (window.__pdpUi) return;
  window.__pdpUi = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)');

  function reveal() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('is-in');
        io.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ''; }, 900);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-pdp-reveal] > *').forEach(function (el, i) {
      if (el.classList.contains('pdp-reveal')) return;
      el.classList.add('pdp-reveal');
      el.style.transitionDelay = (i % 4) * 90 + 'ms';
      io.observe(el);
    });
  }

  function carousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var track = root.querySelector('[data-track]');
    var dotsWrap = root.querySelector('[data-dots]');
    if (!track || !dotsWrap) return;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) { dotsWrap.hidden = true; return; }
    var dots = [], idx = 0, timer = null, userTouched = false, visible = false;

    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pdp-dots__dot';
      b.setAttribute('aria-label', 'Show ' + (i + 1) + ' of ' + cards.length);
      b.addEventListener('click', function () { userTouched = true; stop(); go(i, true); });
      dotsWrap.appendChild(b);
      dots.push(b);
    });

    function go(i, smooth) {
      var first = cards[0];
      track.scrollTo({ left: cards[i].offsetLeft - first.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    }
    function current() {
      var tl = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
      var best = 0, bd = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - tl);
        if (d < bd) { bd = d; best = i; }
      });
      // At the end of the scroll, the last card may never reach the left edge.
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = cards.length - 1;
      return best;
    }
    function paint() {
      idx = current();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; paint(); });
    }, { passive: true });

    function start() {
      stop();
      if (reduce || userTouched || !visible || !mobile.matches) return;
      timer = setInterval(function () { go(idx >= cards.length - 1 ? 0 : idx + 1, true); }, 4500);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, function () { userTouched = true; stop(); }, { passive: true });
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? start() : stop(); }, { threshold: 0.5 }).observe(track);
    }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    if (mobile.addEventListener) mobile.addEventListener('change', function () { paint(); start(); });
    paint();
  }

  function init() {
    reveal();
    document.querySelectorAll('[data-pdp-carousel]').forEach(carousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
